import type { VariantInfo, Campaign, ICampaignVariantVersion } from '~/modules/campaign/types';

import { GVariantBadge } from '~/presentation/ui';
import { Box } from '@shopify/polaris';
import { useMemo } from 'react';

export interface CGTemplatePairPropertyLabelProps {
  variant: VariantInfo;
  campaign: Campaign;
  campaignVariants?: Record<string, ICampaignVariantVersion>;
}

export const CGTemplatePairPropertyLabel: React.FC<CGTemplatePairPropertyLabelProps> = ({
  campaignVariants,
  variant,
}) => {
  const label = useMemo(() => {
    const versionVariantData = variant?.id ? campaignVariants?.[variant.id] : undefined;
    if (versionVariantData?.templateTitle) return versionVariantData?.templateTitle;

    return variant.themePageInfo?.label ?? 'Choose template';
  }, [variant.themePageInfo?.label, variant.id, campaignVariants]);

  return (
    <Box paddingInlineStart="400" maxWidth="100%" width="100%">
      <GVariantBadge
        size="sm"
        isShowWinner={variant.isWinner}
        {...variant.badge}
        labelProps={{
          variant: 'bodyMd',
          fontWeight: 'medium',
          tone: variant?.templateSuffix ? 'base' : 'disabled',
        }}
        label={label}
      />
    </Box>
  );
};
